import React, { useEffect, useState } from "react";

const stats = [
  { label: " Countries Global Presence", value: 100 },
  { label: "Year Strong Experience", value: 45 },
  { label: "Associated with Ministries(Indian. Govt.)", value: 25 },
  { label: "Global Conferences, Seminars, Workshops", value: 75 },
];

const Counter = ({ value }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;
    const duration = 2000;
    const increment = end / (duration / 20);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 20);

    return () => clearInterval(timer);
  }, [value]);

  return <span>{count.toLocaleString()}</span>;
};

const AboutWASMESection = () => {
  return (
    <section
      className="relative bg-fixed bg-center bg-cover"
      style={{ backgroundImage: "url('/img/wasme_office.png')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-slate-900/60" />

      <div className="relative max-w-7xl mx-auto px-6 py-20 text-white">

        {/* Top Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Video */}
          <div className="rounded-xl overflow-hidden shadow-2xl aspect-video">
            <video
              className="w-full h-full object-cover"
              src="/img/Wasme_video.mp4"
              controls
              onLoadedMetadata={(e) => {
                e.currentTarget.currentTime = 13;
              }}
            />

          </div>

          {/* Text */}
          <div>
            <h2 className="text-4xl font-bold mb-6">
              About WASME
            </h2>

            {/* <p className="text-lg leading-relaxed mb-4 font-semibold">
              WASME is the only international NGO that enjoys consultative/ observer status with many UN agencies such as ECOSOC, UNCTAD, ITC, WIPO, UNIDO, UNESCO, UNICITRAL, UNESCAP and ILO, several intergovernmental and international organizations like WCO, OECD, ICSB, APEC, APCTT, etc. to promote and supportMSMEs around the world for more than 45 years.
            </p> */}

            <p className="text-lg font-semibold leading-relaxed">
              We have created world's largest and cohesive community that promotes MSMEs in the world, including UN agencies, national and international organizations, local government bodies, regional authorities, industry associations, MSMEs promotion agencies, financial institutions, research institutes, banks, civil societies to achieve sustainable Development ofMSMEs.
            </p>
          </div>
        </div>

        {/* Counters */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 text-center mt-20">
          {stats.map((item, i) => (
            <div key={i}>
              <h3 className="text-4xl font-bold">
                <Counter value={item.value} />+
              </h3>
              <p className="mt-2 text-lg tracking-wide uppercase">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutWASMESection;
